// src/services/api.js
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const api = axios.create({ baseURL: BASE_URL, timeout: 15000, headers: { 'Content-Type': 'application/json' } });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) config.headers.Authorization = token;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user_data');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  login: (phone, password) => api.post('/auth/login', { phone, password }).then(r => r.data),
};

export const ordersAPI = {
  getAll: (params = {}) => api.get('/orders', { params }).then(r => r.data),
  getById: (id) => api.get(`/orders/${id}`).then(r => r.data),
  create: (data) => api.post('/orders', data).then(r => r.data),
  assign: (id, riderId) => api.post(`/orders/${id}/assign`, { rider_id: riderId }).then(r => r.data),
  updateStatus: (id, status, notes) => api.post(`/orders/${id}/update-status`, { status, notes }).then(r => r.data),
};

export const ridersAPI = {
  getAll: () => api.get('/riders').then(r => r.data),
  getById: (id) => api.get(`/riders/${id}`).then(r => r.data),
};

export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats').then(r => r.data),
};

export const adminAPI = {
  getUsers: () => api.get('/admin/users').then(r => r.data),
  createUser: (data) => api.post('/admin/users', data).then(r => r.data),
  suspendUser: (id) => api.patch(`/admin/users/${id}/suspend`).then(r => r.data),
  activateUser: (id) => api.patch(`/admin/users/${id}/activate`).then(r => r.data),
  resetPassword: (id, new_password) => api.patch(`/admin/users/${id}/reset-password`, { new_password }).then(r => r.data),
  deleteUser: (id) => api.delete(`/admin/users/${id}`).then(r => r.data),
};

export const revenueAPI = {
  getReport: (date_from, date_to) => api.get('/revenue', { params: { date_from, date_to } }).then(r => r.data),
};

export default api;